import { render } from "./new-block.component.vue?vue&type=template&id=22e7959c"
import script from "./new-block.component.vue?vue&type=script&lang=js"
export * from "./new-block.component.vue?vue&type=script&lang=js"

import "./new-block.component.vue?vue&type=style&index=0&id=22e7959c&lang=css"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__